export const hasAnswer = item => String(item.userInput ?? "").trim() !== "";

export const answerState = item => {
  if (item.excludedFromScoring) return "excluded";
  if (item.rightAnswerWasInInput === true) return "correct";
  if (!hasAnswer(item)) return "unanswered";
  if (item.rightAnswerWasInInput === false) return "incorrect";
  return "ungraded";
};

export const isSummaryField = item =>
  ["پاسخ های صحیح", "کل پاسخ ها"].includes(item.title) && !item.rightAnswer &&
  !item.excludedFromScoring && !Object.prototype.hasOwnProperty.call(item, "rightAnswerWasInInput");

export const savedScore = fields => {
  const correct = fields.find(item => isSummaryField(item) && item.title === "پاسخ های صحیح");
  const total = fields.find(item => isSummaryField(item) && item.title === "کل پاسخ ها");
  if (!correct || !total || !hasAnswer(correct) || !hasAnswer(total)) return null;
  const count = Number(correct.userInput), available = Number(total.userInput);
  return Number.isFinite(count) && Number.isFinite(available) && count >= 0 && available >= count
    ? { correct: count, total: available } : null;
};
